
    <p-accordionTab #primeAccordionTab [header]="header" [selected]="isSelected">
      <ng-content></ng-content>
    </p-accordionTab>
  